/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IMfrmFooterViewProps } from './mfrm-footer';
import MFRMFooter from '../../mfrm-components/mfrm-footer/MFRMFooter';

export default (props: IMfrmFooterViewProps) => {
    return (
        <div className='row'>
            <MFRMFooter {...props} />
        </div>
    );
};
